import {detect} from 'detect-browser';
import {startRegistration, verifyAuthentication, browserSupportsWebAuthn} from './web-authn';

export async function createPasskey(options) {
  return await startRegistration(options);
}

export async function getCredential(params) {
  const {publicKeyCredentialRequestOptions, userHandle} = params || {};
  return await verifyAuthentication(publicKeyCredentialRequestOptions, userHandle);
}

export function isSupportPasskey() {
  return browserSupportsWebAuthn();
}

export function genPasskeyDeviceName() {
  const b = detect();
  return `${b.name} on ${b.os}`;
}
